import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { SiteMonitorState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: SiteMonitorState = getDefaultState();

const namespaced: boolean = true;

export const siteMonitor: Module<SiteMonitorState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
